import React, { FC } from "react";

import { DataViewKey } from "@keepeek/commons";
import { withSuspense } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";

import { useDownloadAttachments } from "../../providers/attachment/hooks/download";
import { useElement } from "../../providers/element/hooks";
import AttachmentsByElement from "./AttachmentsByElement";

export type DownloadManagerAttachmentsUnitaryElementProps = {
  dataViewKey: DataViewKey;
};

const DownloadManagerAttachmentsUnitarySharedElement: FC<
  React.PropsWithChildren<DownloadManagerAttachmentsUnitaryElementProps>
> = function ({ dataViewKey }) {
  const { elementId, element } = useElement();
  const { attachments } = useDownloadAttachments({
    elementId: element?.id,
  });

  if (
    elementId === undefined ||
    element === undefined ||
    attachments === undefined ||
    dataViewKey === undefined
  ) {
    return null;
  }

  return (
    <Box
      className={clsx("DownloadManagerAttachmentsUnitarySharedElement")}
      component="ul"
      sx={{
        listStyle: "none",
        padding: 0,
        margin: (theme) => theme.spacing(2, 0),
      }}
    >
      <AttachmentsByElement
        key={element?.id}
        attachmentsByElement={{ elementId, attachments }}
        elements={[element]}
        dataViewKey={dataViewKey}
      />
    </Box>
  );
};

export default withSuspense(DownloadManagerAttachmentsUnitarySharedElement);
